import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import classes from './Footer.module.css'

function Footer() {
  useEffect(() => {
    try{
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    }catch(ex){}
  }, []);
  
  return (
    <>
      <div className="p-4">
        <ins className='adsbygoogle'
            style={{ display: 'block' }}
            data-ad-client='ca-pub-8126596259429304'
            data-ad-slot='5153011292'
            data-ad-format='auto'
        />
      </div>
      <footer className={classes.footer_distributed}>
        <div className={classes.footer_right}>
          <a href="/"><i className="fa-brands fa-facebook-f"></i></a>
          <a href="/"><i className="fa-brands fa-twitter"></i></a>
          <a href="/"><i className="fa-brands fa-linkedin-in"></i></a>
          <a href="/"><i className="fa-brands fa-github-alt"></i></a>
        </div>
        <div className={classes.footer_left}>
          <ul className={classes.footer_links}>
            <li><Link to="/page/4/about-wesharez">About</Link></li>
            <li><Link to="/page/16/contact-us">Contact</Link></li>
            <li><Link to="/page/15/content-removal">Content Removal</Link></li>
            <li><Link to="/page/11/privacy-policy">Privacy Policy</Link></li>
            <li><Link to="/page/18/sitemap">Sitemap</Link></li>
            <li><Link to="/page/2/terms-of-use">Terms Of Use</Link></li>
          </ul>

          <p>
            <span>&copy; 2022 wesharez.com</span>
            <span>Powered by Wesharez™ WESHAREZ</span>
          </p>

        </div>

      </footer>
    </>
  )
}

export default Footer